export const assetUrl = path => `/assets/${path}.png`

const icons = Object.freeze({
    hurlingRocks: assetUrl('itemassets/Units/Elitetool/Elitetool_Unit_Eliteoilsmelter/Elitetool_Unit_Eliteoilsmelter--1573584429307'),
    castleGateReinforcement: assetUrl('itemassets/Units/Dworkshop/Dworkshop_Unit_Gatehardening/Dworkshop_Unit_Gatehardening--1650458944632'),
    flamingArrows: assetUrl('itemassets/Units/Dworkshop/Dworkshop_Unit_Brazier/Dworkshop_Unit_Brazier--1650458944632'),
    sharpenedStakes: assetUrl('itemassets/Units/Dworkshop/Dworkshop_Unit_Stakes/Dworkshop_Unit_Stakes--1650458944632'),
    bodkinArrowheads: assetUrl('itemassets/Units/Elitetool/Elitetool_Unit_Bodkinhead/Elitetool_Unit_Bodkinhead--1573584429307'),
    warHorn: assetUrl('itemassets/Units/Elitetool/Elitetool_Unit_Warhorn/Elitetool_Unit_Warhorn--1573584429307'),
    turtleRam: assetUrl('itemassets/Units/Elitetool/Elitetool_Unit_Tortoise/Elitetool_Unit_Tortoise--1573584429307'),
    grapplingHooks: assetUrl('itemassets/Units/Elitetool/Elitetool_Unit_Grapplinghook/Elitetool_Unit_Grapplinghook--1573584429307'),
    dummyPeasants: assetUrl('itemassets/Units/Elitetool/Elitetool_Unit_Peasantdoll/Elitetool_Unit_Peasantdoll--1573584429307'),
    crabRock: assetUrl('itemassets/Building/Deco/Deco_Building_StormIslandCrab/Deco_Building_StormIslandCrab--1606752868278'),
    whaleLagoon: assetUrl('itemassets/Building/Deco/Deco_Building_StormIslandWhale/Deco_Building_StormIslandWhale--1606752868278'),
    tideGarden: assetUrl('itemassets/Building/Deco/Deco_Building_StormIslandDoor/Deco_Building_StormIslandDoor--1606752868278'),
    aquamarine: assetUrl('itemassets/Building/AquamarineRelic/AquamarineRelic_Building_Level3/AquamarineRelic_Building_Level3--1606752868278'),
    silverPieces: assetUrl('itemassets/Collectables/Collectable_Currency_SilverToken/Collectable_Currency_SilverToken--1573584429307'),
    goldPieces: assetUrl('itemassets/Collectables/Collectable_Currency_GoldToken/Collectable_Currency_GoldToken--1573584429307'),
    skip5h: assetUrl('itemassets/Collectables/Collectable_Currency_5HourSkip/Collectable_Currency_5HourSkip--1573584429307'),
    skip24h: assetUrl('itemassets/Collectables/Collectable_Currency_24HourSkip/Collectable_Currency_24HourSkip--1573584429307'),
    gem: assetUrl('itemassets/Equipment/Equipment_Gems/Equipment_Gems--1573584429307'),
    coins: assetUrl('itemassets/Collectables/Collectable_Currency_RoyalCapitalCoin/Collectable_Currency_RoyalCapitalCoin--1573584429307'),
    constructionProduction: assetUrl('itemassets/ConstructionItems/ConstructionItem_WoodProduction/ConstructionItem_WoodProduction--1573584429307'),
    constructionFoodProduction: assetUrl('itemassets/ConstructionItems/ConstructionItem_FoodProduction/ConstructionItem_FoodProduction--1573584429307'),
    constructionStorage: assetUrl('itemassets/ConstructionItems/ConstructionItem_WoodStorageCapacity/ConstructionItem_WoodStorageCapacity--1573584429307'),
    renegadeNorsemanWarrior: assetUrl('itemassets/Units/Eventunit/Eventunit_Unit_Iceeventmelee/Eventunit_Unit_Iceeventmelee--1573584429307'),
    renegadeNorsemanBowman: assetUrl('itemassets/Units/Eventunit/Eventunit_Unit_Iceeventrange/Eventunit_Unit_Iceeventrange--1573584429307'),
    wolfhound: assetUrl('itemassets/Units/SlumPackages/Eventunit_Unit_Tinoswolves/Eventunit_Unit_Tinoswolves--1573584429307'),
    barbarian: assetUrl('itemassets/Units/SlumPackages/Eventunit_Unit_Conan/Eventunit_Unit_Conan--1573584429307'),
    renegadeSaberWarrior: assetUrl('itemassets/Units/Eventunit/Eventunit_Unit_Deserteventmelee/Eventunit_Unit_Deserteventmelee--1573584429307'),
    renegadeDesertBowman: assetUrl('itemassets/Units/Eventunit/Eventunit_Unit_Deserteventrange/Eventunit_Unit_Deserteventrange--1573584429307'),
    compositeBowman: assetUrl('itemassets/Units/SlumPackages/Eventunit_Unit_Arrowthrower/Eventunit_Unit_Arrowthrower--1573584429307'),
    flameBearer: assetUrl('itemassets/Units/SlumPackages/Eventunit_Unit_Flamethrower/Eventunit_Unit_Flamethrower--1573584429307'),
    renegadeCultistWarrior: assetUrl('itemassets/Units/Eventunit/Eventunit_Unit_Fireeventmelee/Eventunit_Unit_Fireeventmelee--1573584429307'),
    renegadeCultistBowman: assetUrl('itemassets/Units/Eventunit/Eventunit_Unit_Fireeventrange/Eventunit_Unit_Fireeventrange--1573584429307'),
    demonHorror: assetUrl('itemassets/Units/Rewards/Eventunit_Unit_Rankrewardmelee/Eventunit_Unit_Rankrewardmelee--1573584429307'),
    deathlyHorror: assetUrl('itemassets/Units/Rewards/Eventunit_Unit_Rankrewardrange/Eventunit_Unit_Rankrewardrange--1573584429307'),
    luckyWheel: assetUrl('itemassets/Building/Event/Event_Building_LuckyWheel/Event_Building_LuckyWheel--1573584429307'),
    affluenceWheel: assetUrl('itemassets/Building/Event/Event_Building_SaleDaysLuckyWheel/Event_Building_SaleDaysLuckyWheel--1573584429307')
})

export const KHAN_DEFENSE_TOOL_ICON_BY_KEY = Object.freeze({
    buyHurlingRocks: icons.hurlingRocks,
    buyCastleGateReinforcement: icons.castleGateReinforcement,
    buyFlamingArrows: icons.flamingArrows,
    buySharpenedStakes: icons.sharpenedStakes,
    buyBodkinArrowheads: icons.bodkinArrowheads
})

export const AQUA_SHOP_ICON_BY_KEY = Object.freeze({
    enabled: icons.aquamarine,
    buyCrabRock: icons.crabRock,
    buyWhaleLagoon: icons.whaleLagoon,
    buyTideGarden: icons.tideGarden,
    buySilverPieces: icons.silverPieces,
    buyGoldPieces: icons.goldPieces,
    buy5hSkips: icons.skip5h,
    buy24hSkips: icons.skip24h,
    buyGemCastellan: icons.gem,
    buyGemCommander: icons.gem,
    buyWarHorn: icons.warHorn,
    buyTurtleRam: icons.turtleRam,
    buyGrapplingHooks: icons.grapplingHooks,
    buyDummyPeasants: icons.dummyPeasants,
    buyCoins: icons.coins
})

export const WHEEL_MODE_ICON_BY_KEY = Object.freeze({
    normal: icons.luckyWheel,
    affluence: icons.affluenceWheel
})

export const NATIVE_VILLAGE_ITEM_ICON_BY_PACKAGE_ID = Object.freeze({
    100: icons.coins,
    102: icons.renegadeNorsemanWarrior,
    103: icons.renegadeNorsemanBowman,
    104: icons.wolfhound,
    105: icons.barbarian,
    108: icons.coins,
    110: icons.renegadeSaberWarrior,
    111: icons.renegadeDesertBowman,
    112: icons.compositeBowman,
    113: icons.flameBearer,
    116: icons.coins,
    118: icons.renegadeCultistWarrior,
    119: icons.renegadeCultistBowman,
    120: icons.demonHorror,
    121: icons.deathlyHorror,
    2793: icons.constructionFoodProduction,
    2794: icons.constructionProduction,
    3173: icons.constructionStorage,
    3174: icons.constructionProduction,
    3175: icons.constructionProduction,
    3176: icons.constructionStorage,
    3177: icons.constructionStorage,
    3178: icons.constructionProduction,
    3179: icons.constructionStorage
})

export const getNativeVillageItemIconType = item =>
    item?.packageType === 'soldier' ? 'troop' :
        item?.packageType === 'constructionItem' ? 'building' :
            'resource'

export const getNativeVillageItemIconUrl = item =>
    NATIVE_VILLAGE_ITEM_ICON_BY_PACKAGE_ID[String(item?.packageID)] ?? ''
